var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Login',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('h2',{staticClass:"white--text text-center mb-5"},[_vm._v("Welcome to your Sony Rebate & SPIFF Center")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }